<template>
  <v-container>
    <v-row justify="center" v-if="language === 'en'">
      <v-col :cols="12" :sm="6">
        <v-alert type="warning" :value="true">
          The general terms and conditions and the data protection regulations are only available in German and Italian.
        </v-alert>
      </v-col>
    </v-row>
    <template v-if="language === 'it'">
      <agb-it/>
      <privacy-policy-it/>
    </template>
    <template v-else>
      <agb-de/>
      <privacy-policy-de/>
    </template>

  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AgbDe from './agb-content/de/Agb.vue';
import PrivacyPolicyDe from './agb-content/de/PrivacyPolicy.vue';
import AgbIt from './agb-content/it/Agb.vue';
import PrivacyPolicyIt from './agb-content/it/PrivacyPolicy.vue';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  components: {
    AgbDe,
    PrivacyPolicyDe,
    AgbIt,
    PrivacyPolicyIt,
  },
  computed: {
    ...mapUserState([
      'language',
    ]),
  },
};
</script>
